import { todayMelons } from '@/mocks/homeData';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function TodayMelons() {
  return (
    <section id="today" className="border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="今日瓜速递"
          title="1每日吃瓜今日瓜 · 全部按时间排好"
          desc="从早到晚的新鲜爆料与最新八卦，一条不落；点开时间线就能看到同一件事的来龙去脉。"
          action={
            <a
              href="#rank"
              className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-bar-chart-2-line"></i>
              看今日热度榜
            </a>
          }
        />

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {todayMelons.map((melon) => (
            <a
              key={melon.id}
              href="#gossip"
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5 transition hover:border-primary-300 hover:bg-primary-50/50"
            >
              <div className="w-11 shrink-0 pt-0.5 text-center">
                <div className="font-heading text-base leading-none text-primary-600">{melon.time}</div>
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                    {melon.tag}
                  </span>
                  <span className="flex items-center gap-1 text-xs font-medium text-primary-600">
                    <i className="ri-fire-line"></i>
                    {melon.heat}
                  </span>
                </div>

                <h3 className="mt-1.5 text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {melon.title}
                </h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {melon.summary}
                </p>

                <div className="mt-2.5 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {melon.comments} 条讨论
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    今日更新
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-6 flex items-center justify-center gap-2 rounded-lg border border-dashed border-background-300 bg-background-100 px-4 py-3 text-xs text-foreground-500 md:text-sm">
          <i className="ri-loader-4-line"></i>
          今天还有 120 条新瓜在排队，入口打开就能接着刷
        </div>
      </div>
    </section>
  );
}